export const CHANGE_LIST_PARAMS = 'crud/CHANGE_LIST_PARAMS'



// WEBPACK FOOTER //
// ./state/types/list.js